/* Mayhem Universe — minimal scroll-snap carousel.
   The track itself uses native scroll-snap for swipe/drag. This script
   wires up the dot indicators: clicking a dot scrolls to its slide,
   and scrolling updates the active dot.

   Idempotent: safe to re-run on Shopify theme-editor section reload. */
(function () {
  function init(visual) {
    if (visual.dataset.mmCarouselReady === '1') return;
    visual.dataset.mmCarouselReady = '1';

    const track = visual.querySelector('[data-mm-slides]');
    const dots = Array.from(visual.querySelectorAll('[data-mm-dot]'));
    if (!track || dots.length === 0) return;

    const slides = Array.from(track.children);

    const scrollToIndex = (i) => {
      const slide = slides[i];
      if (!slide) return;
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth',
      });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = Number(dot.dataset.mmDot || 0);
        scrollToIndex(idx);
      });
    });

    let scrollFrame = null;
    const updateActive = () => {
      const slideWidth = track.clientWidth;
      if (slideWidth === 0) return;
      const idx = Math.round(track.scrollLeft / slideWidth);
      dots.forEach((d, i) => {
        const active = i === idx;
        d.classList.toggle('is-active', active);
        if (active) d.setAttribute('aria-selected', 'true');
        else d.removeAttribute('aria-selected');
      });
    };
    track.addEventListener('scroll', () => {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(updateActive);
    });

    // Re-snap on resize so dots stay accurate
    window.addEventListener('resize', updateActive);
  }

  function initAll() {
    document.querySelectorAll('[data-mm-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify theme editor reloads sections
  document.addEventListener('shopify:section:load', initAll);
})();
